module.exports = __webpack_public_path__ + "img/L1060693.d4390f11.jpg";